import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaLinkedinIn } from "react-icons/fa";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import ProfileSlideshow from "./ProfileSlideshow";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row className="home-hero-row align-items-center">
            <Col xs={12} md={7} className="home-header order-2 order-md-1">
              <h1 className="heading">
                Hello!{" "}
                <span className="wave" role="img" aria-label="Waving hand">
                  👋🏻
                </span>
              </h1>

              <p className="heading-name">
                I&apos;M
                <strong className="main-name"> Henry H. Chen </strong>
              </p>

              <p className="home-tagline">
                Staff Software Engineer, Applied AI — building production AI
                systems and leading engineering teams.
              </p>

              <div className="typewriter-container">
                <Type />
              </div>

              <div className="home-cta-buttons">
                <Link to="/resume" className="btn btn-primary home-cta-btn">
                  View Resume
                </Link>
                <a
                  href="https://www.linkedin.com/in/henrychen11/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn home-cta-btn home-cta-btn-secondary"
                >
                  <FaLinkedinIn style={{ marginBottom: "2px" }} /> Connect on
                  LinkedIn
                </a>
              </div>
            </Col>

            <Col xs={12} md={5} className="home-photo-col order-1 order-md-2">
              <ProfileSlideshow />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
